import { toIsoDate } from '@/api/reportDateRanges';

/** Parse YYYY-MM-DD as local noon to avoid timezone off-by-one. */
export function isoToLocalDate(iso: string): Date | undefined {
  if (!iso) return undefined;
  const d = new Date(`${iso}T12:00:00`);
  return Number.isNaN(d.getTime()) ? undefined : d;
}

/** Current local calendar day as a Date (noon), matching picker ISO conversion. */
export function getLocalTodayDate(now = new Date()): Date {
  return isoToLocalDate(toIsoDate(now)) ?? now;
}

export function localDateToIso(date: Date | undefined): string {
  if (!date) return '';
  return toIsoDate(date);
}

export function formatDateRangeLabel(startDate: string, endDate: string): string {
  const start = isoToLocalDate(startDate);
  const end = isoToLocalDate(endDate);
  if (!start || !end) return `${startDate} – ${endDate}`;

  const sameYear = start.getFullYear() === end.getFullYear();
  const startLabel = start.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    // Keep year on both sides for single-day ranges so it still reads as a range.
    ...(sameYear && startDate !== endDate ? {} : { year: 'numeric' as const }),
  });
  const endLabel = end.toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
  return `${startLabel} – ${endLabel}`;
}
